import styles from "./ErrorBanner.module.css";

type ErrorBannerProps = {
  error: string;
  onRetry: () => void;
  loading: boolean;
};

function withFullStop(message: string): string {
  return /[.!?…]$/.test(message) ? message : `${message}.`;
}

export function ErrorBanner({ error, onRetry, loading }: ErrorBannerProps) {
  return (
    <div className={styles.errorBanner}>
      <span>{withFullStop(error)}</span>
      <button type="button" onClick={onRetry} disabled={loading} className={styles.retryButton}>
        {loading ? "Retrying..." : "Click to retry"}
      </button>
    </div>
  );
}
